import {
  Component,
  Input,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';

import { Cell } from '../../../lib/data-set/cell';
import { ViewCell } from './view-cell';

@Component({
  selector: 'custom-view-component',
  template: ` <ng-template #dynamicTarget></ng-template> `,
  standalone: false
})
export class CustomViewComponent implements AfterViewInit, OnDestroy {
  public customComponent: any;
  @Input() public cell: Cell;
  @ViewChild('dynamicTarget', { read: ViewContainerRef })
  public dynamicTarget!: ViewContainerRef;

  constructor(private resolver: ComponentFactoryResolver) { }


  public ngAfterViewInit() {
    if (this.cell && !this.customComponent && this.dynamicTarget) {
      this.createCustomComponent();
      if (this.customComponent) {
        this.callOnComponentInit();
        this.patchInstance();
      }
    }
  }

  public ngOnDestroy() {
    if (this.customComponent) {
      this.customComponent.destroy();
    }
  }

  protected createCustomComponent() {
    const componentFactory = this.resolver.resolveComponentFactory(
      this.cell.getColumn().renderComponent,
    );
    if (this.dynamicTarget && typeof this.dynamicTarget.createComponent === 'function') {
      this.customComponent = this.dynamicTarget.createComponent(componentFactory);
    } else {
      console.error('dynamicTarget is not a valid ViewContainerRef');
    }
  }

  protected callOnComponentInit() {
    const onComponentInitFunction = this.cell
      .getColumn()
      .getOnComponentInitFunction();
    let expression =
      onComponentInitFunction &&
      onComponentInitFunction(this.customComponent.instance);
  }

  protected patchInstance() {
    Object.assign(this.customComponent.instance, this.getPatch());
  }

  protected getPatch(): ViewCell {
    return {
      value: this.cell.getValue(),
      rowData: this.cell.getRow().getData()
    };
  }
}
